import { ContextMenu, ContextMenuDeleteWithModelUsageItem, ContextMenuItem, Id, useHasPermission } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PermissionName } from "../../../shared/types/permission";
import { eventCategoryService } from "../shared/api/eventCategoryService";

interface Props {
	eventCategoryId: Id;
	handleEdit: () => void;
	handleDelete: () => Promise<any>;
}

export const EventCategoryListContextMenu: FC<Props> = ({ eventCategoryId, handleEdit, handleDelete }) => {
	const { t } = useTranslation();

	const showUsageAction = useCallback(
		() => eventCategoryService.showUsage(eventCategoryId).then((r) => r.data.data),
		[eventCategoryId],
	);

	const canUpdate = useHasPermission<PermissionName>(["eventCategory.update"]);
	const canDelete = useHasPermission<PermissionName>(["eventCategory.delete"]);

	return (
		<>
			<ContextMenu displayShortcutsAs="icon">
				{canUpdate && (
					<ContextMenuItem label={t("Edit")} action={handleEdit} title={t("Edit")} icon="edit" shortcut="primary" />
				)}
				{canDelete && (
					<ContextMenuDeleteWithModelUsageItem
						label={t("Delete")}
						title={t("Delete")}
						showUsageAction={showUsageAction}
						modelName={t("Event category")}
						confirmationBody={t("Are you sure you want to delete this event category?")}
						deleteAction={handleDelete}
						shortcut="danger"
					/>
				)}
			</ContextMenu>
		</>
	);
};
